var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"FieldValue",class:_vm.className},[_c('div',{staticClass:"FieldValue__label text-muted"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"FieldValue__value"},[_vm._v(" "+_vm._s(_vm.displayValue)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }